import { render } from "./categorySeries.vue?vue&type=template&id=256e64ca"
import script from "./categorySeries.vue?vue&type=script&lang=js"
export * from "./categorySeries.vue?vue&type=script&lang=js"

import "./categorySeries.vue?vue&type=style&index=0&id=256e64ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__